<template>
  <div class="hello">
    <qrcode-stream v-if="!scanres" @decode="onDecode"></qrcode-stream>
    <div v-if="!scanres" @click="backPage" style="margin:10px;">Go back</div>
    <div v-if="scanres" class="success">
      <div>{{message}}</div>
      <div v-if="isSuccess">
        <span class="loading"><span></span><span></span><span></span><span></span></span>
      </div>
    </div>
    <div style="display:none;">{{scanres}}</div>
  </div>
</template>

<script>

export default {
  name: 'HelloWorld',
  data(){
    return {
      scanres:'',
      message: 'Scan Success',
      isSuccess: false
    }
  },
  methods:{
    onDecode (decodedString) {
      this.scanres = decodedString
      if(this.scanres != ''){
        if(decodedString.substr(0,30) == 'https://merchant.fastorder.my/' || decodedString.substr(0,27) == 'https://order.fastorder.my/') {
          this.isSuccess = true
        } else{
          this.message = 'Scan Failed'
        }
      }
      if(this.isSuccess){
        setTimeout(() => {
          window.location.href = this.scanres
        }, 300);
      }
    },
    backPage(){
      window.history.back(-1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello{
  text-align: center;
}
.success{
  font-size: 30px;
}
.loading{
        width: 100px;
        height: 16px;
        margin: 0 auto;
        position: relative;
        top: 3px;
        text-align: center;
        display: inline-block;
    }
    .loading span{
        display: inline-block;
        width: 15px;
        height: 100%;
        margin-right: 5px;
        margin-top: 3px;
        background: #bf12b8;
        -webkit-animation: load 1.04s ease infinite;
    }
    .loading span:last-child{
        margin-right: 0px;
    }
    @-webkit-keyframes load{
        0%{
            opacity: 1;
        }
        100%{
            opacity: 0;
        }
    }
    .loading span:nth-child(1){
        -webkit-animation-delay:0.13s;
    }
    .loading span:nth-child(2){
        -webkit-animation-delay:0.26s;
    }
    .loading span:nth-child(3){
        -webkit-animation-delay:0.39s;
    }
    .loading span:nth-child(4){
        -webkit-animation-delay:0.52s;
    }
    .loading span:nth-child(5){
        -webkit-animation-delay:0.65s;
    }
</style>
